module.exports = __webpack_public_path__ + "img/logo-white-webped.939964ad.jpg";